module.exports = __webpack_public_path__ + "img/tree-01-a-trunk.7f155152.png";